/* tslint:disable */
/* eslint-disable */
/**
 * Dataland QA Service API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../../../../base';
// @ts-ignore
import type { DataPointQaReviewInformation } from '../../../../../../org/dataland/datalandfrontend/openApiClient/qaservice/model';
// @ts-ignore
import type { ErrorResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/qaservice/model';
// @ts-ignore
import type { QaReviewResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/qaservice/model';
// @ts-ignore
import type { QaStatus } from '../../../../../../org/dataland/datalandfrontend/openApiClient/qaservice/model';
/**
 * QaControllerApi - axios parameter creator
 */
export const QaControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Assign a QA review status to a data point.
         * @summary Assign a QA review status to a data point.
         * @param {string} dataPointId The unique identifier of the datapoint.
         * @param {QaStatus} qaStatus The status with regard to Dataland\&#39;s quality assurance process.
         * @param {string} [comment] Optional comment to explain the QA review status change.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeDataPointQaStatus: async (dataPointId: string, qaStatus: QaStatus, comment?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataPointId' is not null or undefined
            assertParamExists('changeDataPointQaStatus', 'dataPointId', dataPointId)
            // verify required parameter 'qaStatus' is not null or undefined
            assertParamExists('changeDataPointQaStatus', 'qaStatus', qaStatus)
            const localVarPath = `/data-points/{dataPointId}`
                .replace(`{${"dataPointId"}}`, encodeURIComponent(String(dataPointId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (qaStatus !== undefined) {
                localVarQueryParameter['qaStatus'] = qaStatus;
            }

            if (comment !== undefined) {
                localVarQueryParameter['comment'] = comment;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Assign a QA review status to a dataset.
         * @summary Assign a QA review status to a dataset.
         * @param {string} dataId The unique identifier of the dataset.
         * @param {QaStatus} qaStatus The status with regard to Dataland\&#39;s quality assurance process.
         * @param {string} [comment] Optional comment to explain the QA review status change.
         * @param {boolean} [overwriteDataPointQaStatus] Boolean flag. If true, the QA status of the data points are overwritten.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeQaStatus: async (dataId: string, qaStatus: QaStatus, comment?: string, overwriteDataPointQaStatus?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataId' is not null or undefined
            assertParamExists('changeQaStatus', 'dataId', dataId)
            // verify required parameter 'qaStatus' is not null or undefined
            assertParamExists('changeQaStatus', 'qaStatus', qaStatus)
            const localVarPath = `/datasets/{dataId}`
                .replace(`{${"dataId"}}`, encodeURIComponent(String(dataId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (qaStatus !== undefined) {
                localVarQueryParameter['qaStatus'] = qaStatus;
            }

            if (comment !== undefined) {
                localVarQueryParameter['comment'] = comment;
            }

            if (overwriteDataPointQaStatus !== undefined) {
                localVarQueryParameter['overwriteDataPointQaStatus'] = overwriteDataPointQaStatus;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a filtered and chronologically ordered list of relevant QA review information.
         * @summary Get QA review information for data points filtered by various filters.
         * @param {string} [companyId] The unique identifier under which a company can be found on Dataland.
         * @param {string} [dataType] The associated reporting framework or data point type (as applicable).
         * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
         * @param {QaStatus} [qaStatus] The status with regard to Dataland\&#39;s quality assurance process.
         * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
         * @param {number} [chunkSize] Only a chunk of all matching, ordered results is returned. This parameter specifies the maximum size of a single chunk. All chunks except possibly the last will have that size.
         * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataPointQaReviewInformation: async (companyId?: string, dataType?: string, reportingPeriod?: string, qaStatus?: QaStatus, showOnlyActive?: boolean, chunkSize?: number, chunkIndex?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-points`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (dataType !== undefined) {
                localVarQueryParameter['dataType'] = dataType;
            }

            if (reportingPeriod !== undefined) {
                localVarQueryParameter['reportingPeriod'] = reportingPeriod;
            }

            if (qaStatus !== undefined) {
                localVarQueryParameter['qaStatus'] = qaStatus;
            }

            if (showOnlyActive !== undefined) {
                localVarQueryParameter['showOnlyActive'] = showOnlyActive;
            }

            if (chunkSize !== undefined) {
                localVarQueryParameter['chunkSize'] = chunkSize;
            }

            if (chunkIndex !== undefined) {
                localVarQueryParameter['chunkIndex'] = chunkIndex;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the QA review information of uploaded data point for a given id.Users can get the review information of their own data points.Admins, judges and reviewer can get the review information for all data points.
         * @summary Get the QA review information of an uploaded data point for a given id.
         * @param {string} dataPointId The unique identifier of the datapoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataPointQaReviewInformationByDataId: async (dataPointId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataPointId' is not null or undefined
            assertParamExists('getDataPointQaReviewInformationByDataId', 'dataPointId', dataPointId)
            const localVarPath = `/data-points/{dataPointId}`
                .replace(`{${"dataPointId"}}`, encodeURIComponent(String(dataPointId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves an ordered list of all QA review items currently in status \'Pending\' in reverse chronological order.
         * @summary Get the content of the data point review queue.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataPointReviewQueue: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-points/queue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a filtered and chronologically ordered list of relevant meta info on datasets.
         * @summary Get relevant meta info on datasets.
         * @param {Set<GetInfoOnDatasetsDataTypesEnum>} [dataTypes] The associated reporting framework or data point type (as applicable).
         * @param {Set<string>} [reportingPeriods] The relevant reporting periods (e.g. fiscal years).
         * @param {string} [companyName] The official name of the company.
         * @param {QaStatus} [qaStatus] The status with regard to Dataland\&#39;s quality assurance process.
         * @param {number} [chunkSize] Only a chunk of all matching, ordered results is returned. This parameter specifies the maximum size of a single chunk. All chunks except possibly the last will have that size.
         * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfoOnDatasets: async (dataTypes?: Set<GetInfoOnDatasetsDataTypesEnum>, reportingPeriods?: Set<string>, companyName?: string, qaStatus?: QaStatus, chunkSize?: number, chunkIndex?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/datasets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (dataTypes) {
                localVarQueryParameter['dataTypes'] = Array.from(dataTypes);
            }

            if (reportingPeriods) {
                localVarQueryParameter['reportingPeriods'] = Array.from(reportingPeriods);
            }

            if (companyName !== undefined) {
                localVarQueryParameter['companyName'] = companyName;
            }

            if (qaStatus !== undefined) {
                localVarQueryParameter['qaStatus'] = qaStatus;
            }

            if (chunkSize !== undefined) {
                localVarQueryParameter['chunkSize'] = chunkSize;
            }

            if (chunkIndex !== undefined) {
                localVarQueryParameter['chunkIndex'] = chunkIndex;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets chronologically ordered list of relevant meta info on datasets with QA status pending. Filtering for company name or ID is possible
         * @summary Get relevant meta info on datasets with QA status pending.
         * @param {string} [companyName] The official name of the company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfoOnPendingDatasets: async (companyName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/datasets/queue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (companyName !== undefined) {
                localVarQueryParameter['companyName'] = companyName;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the number of unreviewed datasets based on filters.
         * @summary Get the number of unreviewed datasets based on filters.
         * @param {Set<GetNumberOfPendingDatasetsDataTypesEnum>} [dataTypes] The associated reporting framework or data point type (as applicable).
         * @param {Set<string>} [reportingPeriods] The relevant reporting periods (e.g. fiscal years).
         * @param {string} [companyName] The official name of the company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumberOfPendingDatasets: async (dataTypes?: Set<GetNumberOfPendingDatasetsDataTypesEnum>, reportingPeriods?: Set<string>, companyName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/numberOfUnreviewedDatasets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (dataTypes) {
                localVarQueryParameter['dataTypes'] = Array.from(dataTypes);
            }

            if (reportingPeriods) {
                localVarQueryParameter['reportingPeriods'] = Array.from(reportingPeriods);
            }

            if (companyName !== undefined) {
                localVarQueryParameter['companyName'] = companyName;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the QA review information of uploaded dataset for a given id.Users can get the review information of their own datasets.Admins, judges and reviewer can get the review information for all datasets.
         * @summary Get the QA review information of an uploaded dataset for a given id.
         * @param {string} dataId The unique identifier of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQaReviewResponseByDataId: async (dataId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataId' is not null or undefined
            assertParamExists('getQaReviewResponseByDataId', 'dataId', dataId)
            const localVarPath = `/datasets/{dataId}`
                .replace(`{${"dataId"}}`, encodeURIComponent(String(dataId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QaControllerApi - functional programming interface
 */
export const QaControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QaControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Assign a QA review status to a data point.
         * @summary Assign a QA review status to a data point.
         * @param {string} dataPointId The unique identifier of the datapoint.
         * @param {QaStatus} qaStatus The status with regard to Dataland\&#39;s quality assurance process.
         * @param {string} [comment] Optional comment to explain the QA review status change.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeDataPointQaStatus(dataPointId: string, qaStatus: QaStatus, comment?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeDataPointQaStatus(dataPointId, qaStatus, comment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QaControllerApi.changeDataPointQaStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Assign a QA review status to a dataset.
         * @summary Assign a QA review status to a dataset.
         * @param {string} dataId The unique identifier of the dataset.
         * @param {QaStatus} qaStatus The status with regard to Dataland\&#39;s quality assurance process.
         * @param {string} [comment] Optional comment to explain the QA review status change.
         * @param {boolean} [overwriteDataPointQaStatus] Boolean flag. If true, the QA status of the data points are overwritten.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeQaStatus(dataId: string, qaStatus: QaStatus, comment?: string, overwriteDataPointQaStatus?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeQaStatus(dataId, qaStatus, comment, overwriteDataPointQaStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QaControllerApi.changeQaStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets a filtered and chronologically ordered list of relevant QA review information.
         * @summary Get QA review information for data points filtered by various filters.
         * @param {string} [companyId] The unique identifier under which a company can be found on Dataland.
         * @param {string} [dataType] The associated reporting framework or data point type (as applicable).
         * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
         * @param {QaStatus} [qaStatus] The status with regard to Dataland\&#39;s quality assurance process.
         * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
         * @param {number} [chunkSize] Only a chunk of all matching, ordered results is returned. This parameter specifies the maximum size of a single chunk. All chunks except possibly the last will have that size.
         * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataPointQaReviewInformation(companyId?: string, dataType?: string, reportingPeriod?: string, qaStatus?: QaStatus, showOnlyActive?: boolean, chunkSize?: number, chunkIndex?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataPointQaReviewInformation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataPointQaReviewInformation(companyId, dataType, reportingPeriod, qaStatus, showOnlyActive, chunkSize, chunkIndex, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QaControllerApi.getDataPointQaReviewInformation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the QA review information of uploaded data point for a given id.Users can get the review information of their own data points.Admins, judges and reviewer can get the review information for all data points.
         * @summary Get the QA review information of an uploaded data point for a given id.
         * @param {string} dataPointId The unique identifier of the datapoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataPointQaReviewInformationByDataId(dataPointId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataPointQaReviewInformation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataPointQaReviewInformationByDataId(dataPointId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QaControllerApi.getDataPointQaReviewInformationByDataId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves an ordered list of all QA review items currently in status \'Pending\' in reverse chronological order.
         * @summary Get the content of the data point review queue.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataPointReviewQueue(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataPointQaReviewInformation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataPointReviewQueue(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QaControllerApi.getDataPointReviewQueue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets a filtered and chronologically ordered list of relevant meta info on datasets.
         * @summary Get relevant meta info on datasets.
         * @param {Set<GetInfoOnDatasetsDataTypesEnum>} [dataTypes] The associated reporting framework or data point type (as applicable).
         * @param {Set<string>} [reportingPeriods] The relevant reporting periods (e.g. fiscal years).
         * @param {string} [companyName] The official name of the company.
         * @param {QaStatus} [qaStatus] The status with regard to Dataland\&#39;s quality assurance process.
         * @param {number} [chunkSize] Only a chunk of all matching, ordered results is returned. This parameter specifies the maximum size of a single chunk. All chunks except possibly the last will have that size.
         * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInfoOnDatasets(dataTypes?: Set<GetInfoOnDatasetsDataTypesEnum>, reportingPeriods?: Set<string>, companyName?: string, qaStatus?: QaStatus, chunkSize?: number, chunkIndex?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QaReviewResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInfoOnDatasets(dataTypes, reportingPeriods, companyName, qaStatus, chunkSize, chunkIndex, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QaControllerApi.getInfoOnDatasets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets chronologically ordered list of relevant meta info on datasets with QA status pending. Filtering for company name or ID is possible
         * @summary Get relevant meta info on datasets with QA status pending.
         * @param {string} [companyName] The official name of the company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInfoOnPendingDatasets(companyName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QaReviewResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInfoOnPendingDatasets(companyName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QaControllerApi.getInfoOnPendingDatasets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the number of unreviewed datasets based on filters.
         * @summary Get the number of unreviewed datasets based on filters.
         * @param {Set<GetNumberOfPendingDatasetsDataTypesEnum>} [dataTypes] The associated reporting framework or data point type (as applicable).
         * @param {Set<string>} [reportingPeriods] The relevant reporting periods (e.g. fiscal years).
         * @param {string} [companyName] The official name of the company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNumberOfPendingDatasets(dataTypes?: Set<GetNumberOfPendingDatasetsDataTypesEnum>, reportingPeriods?: Set<string>, companyName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNumberOfPendingDatasets(dataTypes, reportingPeriods, companyName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QaControllerApi.getNumberOfPendingDatasets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the QA review information of uploaded dataset for a given id.Users can get the review information of their own datasets.Admins, judges and reviewer can get the review information for all datasets.
         * @summary Get the QA review information of an uploaded dataset for a given id.
         * @param {string} dataId The unique identifier of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQaReviewResponseByDataId(dataId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QaReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQaReviewResponseByDataId(dataId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QaControllerApi.getQaReviewResponseByDataId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QaControllerApi - factory interface
 */
export const QaControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QaControllerApiFp(configuration)
    return {
        /**
         * Assign a QA review status to a data point.
         * @summary Assign a QA review status to a data point.
         * @param {string} dataPointId The unique identifier of the datapoint.
         * @param {QaStatus} qaStatus The status with regard to Dataland\&#39;s quality assurance process.
         * @param {string} [comment] Optional comment to explain the QA review status change.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeDataPointQaStatus(dataPointId: string, qaStatus: QaStatus, comment?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changeDataPointQaStatus(dataPointId, qaStatus, comment, options).then((request) => request(axios, basePath));
        },
        /**
         * Assign a QA review status to a dataset.
         * @summary Assign a QA review status to a dataset.
         * @param {string} dataId The unique identifier of the dataset.
         * @param {QaStatus} qaStatus The status with regard to Dataland\&#39;s quality assurance process.
         * @param {string} [comment] Optional comment to explain the QA review status change.
         * @param {boolean} [overwriteDataPointQaStatus] Boolean flag. If true, the QA status of the data points are overwritten.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeQaStatus(dataId: string, qaStatus: QaStatus, comment?: string, overwriteDataPointQaStatus?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changeQaStatus(dataId, qaStatus, comment, overwriteDataPointQaStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a filtered and chronologically ordered list of relevant QA review information.
         * @summary Get QA review information for data points filtered by various filters.
         * @param {string} [companyId] The unique identifier under which a company can be found on Dataland.
         * @param {string} [dataType] The associated reporting framework or data point type (as applicable).
         * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
         * @param {QaStatus} [qaStatus] The status with regard to Dataland\&#39;s quality assurance process.
         * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
         * @param {number} [chunkSize] Only a chunk of all matching, ordered results is returned. This parameter specifies the maximum size of a single chunk. All chunks except possibly the last will have that size.
         * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataPointQaReviewInformation(companyId?: string, dataType?: string, reportingPeriod?: string, qaStatus?: QaStatus, showOnlyActive?: boolean, chunkSize?: number, chunkIndex?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataPointQaReviewInformation>> {
            return localVarFp.getDataPointQaReviewInformation(companyId, dataType, reportingPeriod, qaStatus, showOnlyActive, chunkSize, chunkIndex, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the QA review information of uploaded data point for a given id.Users can get the review information of their own data points.Admins, judges and reviewer can get the review information for all data points.
         * @summary Get the QA review information of an uploaded data point for a given id.
         * @param {string} dataPointId The unique identifier of the datapoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataPointQaReviewInformationByDataId(dataPointId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataPointQaReviewInformation>> {
            return localVarFp.getDataPointQaReviewInformationByDataId(dataPointId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves an ordered list of all QA review items currently in status \'Pending\' in reverse chronological order.
         * @summary Get the content of the data point review queue.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataPointReviewQueue(options?: RawAxiosRequestConfig): AxiosPromise<Array<DataPointQaReviewInformation>> {
            return localVarFp.getDataPointReviewQueue(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a filtered and chronologically ordered list of relevant meta info on datasets.
         * @summary Get relevant meta info on datasets.
         * @param {Set<GetInfoOnDatasetsDataTypesEnum>} [dataTypes] The associated reporting framework or data point type (as applicable).
         * @param {Set<string>} [reportingPeriods] The relevant reporting periods (e.g. fiscal years).
         * @param {string} [companyName] The official name of the company.
         * @param {QaStatus} [qaStatus] The status with regard to Dataland\&#39;s quality assurance process.
         * @param {number} [chunkSize] Only a chunk of all matching, ordered results is returned. This parameter specifies the maximum size of a single chunk. All chunks except possibly the last will have that size.
         * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfoOnDatasets(dataTypes?: Set<GetInfoOnDatasetsDataTypesEnum>, reportingPeriods?: Set<string>, companyName?: string, qaStatus?: QaStatus, chunkSize?: number, chunkIndex?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<QaReviewResponse>> {
            return localVarFp.getInfoOnDatasets(dataTypes, reportingPeriods, companyName, qaStatus, chunkSize, chunkIndex, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets chronologically ordered list of relevant meta info on datasets with QA status pending. Filtering for company name or ID is possible
         * @summary Get relevant meta info on datasets with QA status pending.
         * @param {string} [companyName] The official name of the company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfoOnPendingDatasets(companyName?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<QaReviewResponse>> {
            return localVarFp.getInfoOnPendingDatasets(companyName, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the number of unreviewed datasets based on filters.
         * @summary Get the number of unreviewed datasets based on filters.
         * @param {Set<GetNumberOfPendingDatasetsDataTypesEnum>} [dataTypes] The associated reporting framework or data point type (as applicable).
         * @param {Set<string>} [reportingPeriods] The relevant reporting periods (e.g. fiscal years).
         * @param {string} [companyName] The official name of the company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumberOfPendingDatasets(dataTypes?: Set<GetNumberOfPendingDatasetsDataTypesEnum>, reportingPeriods?: Set<string>, companyName?: string, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getNumberOfPendingDatasets(dataTypes, reportingPeriods, companyName, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the QA review information of uploaded dataset for a given id.Users can get the review information of their own datasets.Admins, judges and reviewer can get the review information for all datasets.
         * @summary Get the QA review information of an uploaded dataset for a given id.
         * @param {string} dataId The unique identifier of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQaReviewResponseByDataId(dataId: string, options?: RawAxiosRequestConfig): AxiosPromise<QaReviewResponse> {
            return localVarFp.getQaReviewResponseByDataId(dataId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QaControllerApi - interface
 */
export interface QaControllerApiInterface {
    /**
     * Assign a QA review status to a data point.
     * @summary Assign a QA review status to a data point.
     * @param {string} dataPointId The unique identifier of the datapoint.
     * @param {QaStatus} qaStatus The status with regard to Dataland\&#39;s quality assurance process.
     * @param {string} [comment] Optional comment to explain the QA review status change.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changeDataPointQaStatus(dataPointId: string, qaStatus: QaStatus, comment?: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Assign a QA review status to a dataset.
     * @summary Assign a QA review status to a dataset.
     * @param {string} dataId The unique identifier of the dataset.
     * @param {QaStatus} qaStatus The status with regard to Dataland\&#39;s quality assurance process.
     * @param {string} [comment] Optional comment to explain the QA review status change.
     * @param {boolean} [overwriteDataPointQaStatus] Boolean flag. If true, the QA status of the data points are overwritten.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changeQaStatus(dataId: string, qaStatus: QaStatus, comment?: string, overwriteDataPointQaStatus?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Gets a filtered and chronologically ordered list of relevant QA review information.
     * @summary Get QA review information for data points filtered by various filters.
     * @param {string} [companyId] The unique identifier under which a company can be found on Dataland.
     * @param {string} [dataType] The associated reporting framework or data point type (as applicable).
     * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
     * @param {QaStatus} [qaStatus] The status with regard to Dataland\&#39;s quality assurance process.
     * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
     * @param {number} [chunkSize] Only a chunk of all matching, ordered results is returned. This parameter specifies the maximum size of a single chunk. All chunks except possibly the last will have that size.
     * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDataPointQaReviewInformation(companyId?: string, dataType?: string, reportingPeriod?: string, qaStatus?: QaStatus, showOnlyActive?: boolean, chunkSize?: number, chunkIndex?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataPointQaReviewInformation>>;

    /**
     * Get the QA review information of uploaded data point for a given id.Users can get the review information of their own data points.Admins, judges and reviewer can get the review information for all data points.
     * @summary Get the QA review information of an uploaded data point for a given id.
     * @param {string} dataPointId The unique identifier of the datapoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDataPointQaReviewInformationByDataId(dataPointId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataPointQaReviewInformation>>;

    /**
     * Retrieves an ordered list of all QA review items currently in status \'Pending\' in reverse chronological order.
     * @summary Get the content of the data point review queue.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDataPointReviewQueue(options?: RawAxiosRequestConfig): AxiosPromise<Array<DataPointQaReviewInformation>>;

    /**
     * Gets a filtered and chronologically ordered list of relevant meta info on datasets.
     * @summary Get relevant meta info on datasets.
     * @param {Set<GetInfoOnDatasetsDataTypesEnum>} [dataTypes] The associated reporting framework or data point type (as applicable).
     * @param {Set<string>} [reportingPeriods] The relevant reporting periods (e.g. fiscal years).
     * @param {string} [companyName] The official name of the company.
     * @param {QaStatus} [qaStatus] The status with regard to Dataland\&#39;s quality assurance process.
     * @param {number} [chunkSize] Only a chunk of all matching, ordered results is returned. This parameter specifies the maximum size of a single chunk. All chunks except possibly the last will have that size.
     * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInfoOnDatasets(dataTypes?: Set<GetInfoOnDatasetsDataTypesEnum>, reportingPeriods?: Set<string>, companyName?: string, qaStatus?: QaStatus, chunkSize?: number, chunkIndex?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<QaReviewResponse>>;

    /**
     * Gets chronologically ordered list of relevant meta info on datasets with QA status pending. Filtering for company name or ID is possible
     * @summary Get relevant meta info on datasets with QA status pending.
     * @param {string} [companyName] The official name of the company.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInfoOnPendingDatasets(companyName?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<QaReviewResponse>>;

    /**
     * Get the number of unreviewed datasets based on filters.
     * @summary Get the number of unreviewed datasets based on filters.
     * @param {Set<GetNumberOfPendingDatasetsDataTypesEnum>} [dataTypes] The associated reporting framework or data point type (as applicable).
     * @param {Set<string>} [reportingPeriods] The relevant reporting periods (e.g. fiscal years).
     * @param {string} [companyName] The official name of the company.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNumberOfPendingDatasets(dataTypes?: Set<GetNumberOfPendingDatasetsDataTypesEnum>, reportingPeriods?: Set<string>, companyName?: string, options?: RawAxiosRequestConfig): AxiosPromise<number>;

    /**
     * Get the QA review information of uploaded dataset for a given id.Users can get the review information of their own datasets.Admins, judges and reviewer can get the review information for all datasets.
     * @summary Get the QA review information of an uploaded dataset for a given id.
     * @param {string} dataId The unique identifier of the dataset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getQaReviewResponseByDataId(dataId: string, options?: RawAxiosRequestConfig): AxiosPromise<QaReviewResponse>;

}

/**
 * QaControllerApi - object-oriented interface
 */
export class QaControllerApi extends BaseAPI implements QaControllerApiInterface {
    /**
     * Assign a QA review status to a data point.
     * @summary Assign a QA review status to a data point.
     * @param {string} dataPointId The unique identifier of the datapoint.
     * @param {QaStatus} qaStatus The status with regard to Dataland\&#39;s quality assurance process.
     * @param {string} [comment] Optional comment to explain the QA review status change.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public changeDataPointQaStatus(dataPointId: string, qaStatus: QaStatus, comment?: string, options?: RawAxiosRequestConfig) {
        return QaControllerApiFp(this.configuration).changeDataPointQaStatus(dataPointId, qaStatus, comment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Assign a QA review status to a dataset.
     * @summary Assign a QA review status to a dataset.
     * @param {string} dataId The unique identifier of the dataset.
     * @param {QaStatus} qaStatus The status with regard to Dataland\&#39;s quality assurance process.
     * @param {string} [comment] Optional comment to explain the QA review status change.
     * @param {boolean} [overwriteDataPointQaStatus] Boolean flag. If true, the QA status of the data points are overwritten.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public changeQaStatus(dataId: string, qaStatus: QaStatus, comment?: string, overwriteDataPointQaStatus?: boolean, options?: RawAxiosRequestConfig) {
        return QaControllerApiFp(this.configuration).changeQaStatus(dataId, qaStatus, comment, overwriteDataPointQaStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a filtered and chronologically ordered list of relevant QA review information.
     * @summary Get QA review information for data points filtered by various filters.
     * @param {string} [companyId] The unique identifier under which a company can be found on Dataland.
     * @param {string} [dataType] The associated reporting framework or data point type (as applicable).
     * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
     * @param {QaStatus} [qaStatus] The status with regard to Dataland\&#39;s quality assurance process.
     * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
     * @param {number} [chunkSize] Only a chunk of all matching, ordered results is returned. This parameter specifies the maximum size of a single chunk. All chunks except possibly the last will have that size.
     * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDataPointQaReviewInformation(companyId?: string, dataType?: string, reportingPeriod?: string, qaStatus?: QaStatus, showOnlyActive?: boolean, chunkSize?: number, chunkIndex?: number, options?: RawAxiosRequestConfig) {
        return QaControllerApiFp(this.configuration).getDataPointQaReviewInformation(companyId, dataType, reportingPeriod, qaStatus, showOnlyActive, chunkSize, chunkIndex, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the QA review information of uploaded data point for a given id.Users can get the review information of their own data points.Admins, judges and reviewer can get the review information for all data points.
     * @summary Get the QA review information of an uploaded data point for a given id.
     * @param {string} dataPointId The unique identifier of the datapoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDataPointQaReviewInformationByDataId(dataPointId: string, options?: RawAxiosRequestConfig) {
        return QaControllerApiFp(this.configuration).getDataPointQaReviewInformationByDataId(dataPointId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves an ordered list of all QA review items currently in status \'Pending\' in reverse chronological order.
     * @summary Get the content of the data point review queue.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDataPointReviewQueue(options?: RawAxiosRequestConfig) {
        return QaControllerApiFp(this.configuration).getDataPointReviewQueue(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a filtered and chronologically ordered list of relevant meta info on datasets.
     * @summary Get relevant meta info on datasets.
     * @param {Set<GetInfoOnDatasetsDataTypesEnum>} [dataTypes] The associated reporting framework or data point type (as applicable).
     * @param {Set<string>} [reportingPeriods] The relevant reporting periods (e.g. fiscal years).
     * @param {string} [companyName] The official name of the company.
     * @param {QaStatus} [qaStatus] The status with regard to Dataland\&#39;s quality assurance process.
     * @param {number} [chunkSize] Only a chunk of all matching, ordered results is returned. This parameter specifies the maximum size of a single chunk. All chunks except possibly the last will have that size.
     * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getInfoOnDatasets(dataTypes?: Set<GetInfoOnDatasetsDataTypesEnum>, reportingPeriods?: Set<string>, companyName?: string, qaStatus?: QaStatus, chunkSize?: number, chunkIndex?: number, options?: RawAxiosRequestConfig) {
        return QaControllerApiFp(this.configuration).getInfoOnDatasets(dataTypes, reportingPeriods, companyName, qaStatus, chunkSize, chunkIndex, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets chronologically ordered list of relevant meta info on datasets with QA status pending. Filtering for company name or ID is possible
     * @summary Get relevant meta info on datasets with QA status pending.
     * @param {string} [companyName] The official name of the company.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getInfoOnPendingDatasets(companyName?: string, options?: RawAxiosRequestConfig) {
        return QaControllerApiFp(this.configuration).getInfoOnPendingDatasets(companyName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the number of unreviewed datasets based on filters.
     * @summary Get the number of unreviewed datasets based on filters.
     * @param {Set<GetNumberOfPendingDatasetsDataTypesEnum>} [dataTypes] The associated reporting framework or data point type (as applicable).
     * @param {Set<string>} [reportingPeriods] The relevant reporting periods (e.g. fiscal years).
     * @param {string} [companyName] The official name of the company.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNumberOfPendingDatasets(dataTypes?: Set<GetNumberOfPendingDatasetsDataTypesEnum>, reportingPeriods?: Set<string>, companyName?: string, options?: RawAxiosRequestConfig) {
        return QaControllerApiFp(this.configuration).getNumberOfPendingDatasets(dataTypes, reportingPeriods, companyName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the QA review information of uploaded dataset for a given id.Users can get the review information of their own datasets.Admins, judges and reviewer can get the review information for all datasets.
     * @summary Get the QA review information of an uploaded dataset for a given id.
     * @param {string} dataId The unique identifier of the dataset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getQaReviewResponseByDataId(dataId: string, options?: RawAxiosRequestConfig) {
        return QaControllerApiFp(this.configuration).getQaReviewResponseByDataId(dataId, options).then((request) => request(this.axios, this.basePath));
    }
}

export const GetInfoOnDatasetsDataTypesEnum = {
    Sfdr: 'sfdr',
    EutaxonomyFinancials: 'eutaxonomy-financials',
    EutaxonomyFinancials202673: 'eutaxonomy-financials-2026-73',
    EutaxonomyNonFinancials: 'eutaxonomy-non-financials',
    EutaxonomyNonFinancials202673: 'eutaxonomy-non-financials-2026-73',
    NuclearAndGas: 'nuclear-and-gas',
    Lksg: 'lksg',
    Pcaf: 'pcaf'
} as const;
export type GetInfoOnDatasetsDataTypesEnum = typeof GetInfoOnDatasetsDataTypesEnum[keyof typeof GetInfoOnDatasetsDataTypesEnum];
export const GetNumberOfPendingDatasetsDataTypesEnum = {
    Sfdr: 'sfdr',
    EutaxonomyFinancials: 'eutaxonomy-financials',
    EutaxonomyFinancials202673: 'eutaxonomy-financials-2026-73',
    EutaxonomyNonFinancials: 'eutaxonomy-non-financials',
    EutaxonomyNonFinancials202673: 'eutaxonomy-non-financials-2026-73',
    NuclearAndGas: 'nuclear-and-gas',
    Lksg: 'lksg',
    Pcaf: 'pcaf'
} as const;
export type GetNumberOfPendingDatasetsDataTypesEnum = typeof GetNumberOfPendingDatasetsDataTypesEnum[keyof typeof GetNumberOfPendingDatasetsDataTypesEnum];
